var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-button',_vm._b({staticClass:"md-primary base-button",class:{'css-outline': _vm.cssOutline},on:{"click":function($event){return _vm.$emit('click')}}},'md-button',_vm.$attrs,false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }